/// <reference path="./raw.d.ts" />

import easyBalanceSource from "../../../data/balance/easy.jsonc?raw";
import normalBalanceSource from "../../../data/balance/normal.jsonc?raw";
import hardBalanceSource from "../../../data/balance/hard.jsonc?raw";
import { parseJsonc } from "./parseJsonc";
import type { BalanceConfig } from "./types";
import { validateBalanceConfig } from "./validate";

/** 所有支持的模式难度键。 */
export type DifficultyKey = "easy" | "normal" | "hard";

const easyBalance = parseJsonc(easyBalanceSource, "data/balance/easy.jsonc");
const normalBalance = parseJsonc(normalBalanceSource, "data/balance/normal.jsonc");
const hardBalance = parseJsonc(hardBalanceSource, "data/balance/hard.jsonc");

export const BALANCE_EASY: BalanceConfig = validateBalanceConfig(easyBalance, "balance.easy");
export const BALANCE_NORMAL: BalanceConfig = validateBalanceConfig(normalBalance, "balance.normal");
export const BALANCE_HARD: BalanceConfig = validateBalanceConfig(hardBalance, "balance.hard");

const DIFFICULTY_BY_KEY: Record<DifficultyKey, BalanceConfig> = {
  easy: BALANCE_EASY,
  normal: BALANCE_NORMAL,
  hard: BALANCE_HARD,
};

/** 将用户输入标准化为已知难度键。 */
export function normalizeDifficulty(input: string): DifficultyKey {
  const s = input.trim().toLowerCase();
  if (s === "easy" || s === "e") return "easy";
  if (s === "hard" || s === "h") return "hard";
  return "normal";
}

/** 返回指定难度的默认 JSON 平衡配置。 */
export function getDefaultBalance(_mapId: string, difficulty: string): BalanceConfig {
  return DIFFICULTY_BY_KEY[normalizeDifficulty(difficulty)];
}

/** 返回所有已注册的难度键。 */
export function listDifficulties(): DifficultyKey[] {
  return Object.keys(DIFFICULTY_BY_KEY) as DifficultyKey[];
}

/** 返回每种难度的易读名称。 */
export function getDifficultyNames(): Record<DifficultyKey, string> {
  return {
    easy: "Easy",
    normal: "Normal",
    hard: "Hard",
  };
}
